import {Image} from "../Image/Image";
import team from "../../data/team.json";

function Post({title, content, creation, author}) {
    const date = new Date(creation);

    const day = String(date.getDay()).padStart(2, "0");
    const month = String(date.getMonth()).padStart(2, "0");
    const year = String(date.getFullYear()).padStart(4, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const person = team.people.find((person) => person.first_name === author.name);

    return (
        <article className="flex flex-col w-full mx-auto">
            <div>
                <div className="flex flex-col mb-2">
                    <h2 className="text-2xl italic font-medium text-gray-900">
                        {title}
                    </h2>
                    <h3 className="text-sm text-gray-500">{`Le ${day}.${month}.${year} à ${hours}:${minutes}`}</h3>
                </div>
                <div className="text-lg text-gray-900" style={{wordWrap: "break-word"}}
                     dangerouslySetInnerHTML={{__html: content}}></div>
            </div>
            <div className="flex items-center justify-center mt-6 space-x-3">
                {author.image &&
                    <Image className="w-10 h-10 rounded-full object-cover object-top"
                           src={author.image}
                           alt={author.name}/>
                }
                <div className="flex items-center divide-x-2 divide-primary h-fit">
                    <cite className="flex flex-col pe-3 font-medium text-primary">
                        <span>
                            {person ? (person.first_name + " " + person.last_name) : author.name}
                        </span>
                        <span className="text-sm text-gray-500">
                            {person?.role}
                        </span>
                    </cite>
                </div>
            </div>
        </article>
    );
}

export default Post;